import { h } from 'preact'
import { PureComponent } from 'preact/compat'
import styles from './footer.module.css'

export class Footer extends PureComponent {
  render() {
    return (
      <div className={styles.footer}>
        <div className={styles.byline_block}>
          <nav className={styles.byline_sharebutton_container}>
            <ul className={styles.byline_sharebutton_group}>
              <li className={styles.byline_sharebutton_item}>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a /*className={styles.to_top}*/ href="#">
                  <strong>Gå til toppen</strong>
                  <button className="nrk-button nrk-button--o">
                    <svg width="30" height="30" aria-hidden="true">
                      <use xlinkHref="#nrk-chevron-up" />
                    </svg>
                  </button>
                </a>
              </li>
              <li className={styles.byline_sharebutton_item}>
                <a
                  className=""
                  data-share="Article:Facebook"
                  rel="noopener"
                  target="_blank"
                  href="https://www.nrk.no/sperret-inne_-slatt-og-lenket-fast-1.13769828"
                >
                  Del på Facebook
                  <button className="nrk-button nrk-button--o">
                    <svg width="30" height="30" aria-hidden="true">
                      <use xlinkHref="#nrk-some-facebook" />
                    </svg>
                  </button>
                </a>
              </li>
              <li className={styles.byline_sharebutton_item}>
                <a
                  className=""
                  data-share="Article:Twitter"
                  rel="noopener"
                  target="_blank"
                  href="https://www.nrk.no/sperret-inne_-slatt-og-lenket-fast-1.13769828"
                >
                  Del på Twitter
                  <button className="nrk-button nrk-button--o">
                    <svg width="30" height="30" aria-hidden="true">
                      <use xlinkHref="#nrk-some-twitter" />
                    </svg>
                  </button>
                </a>
              </li>
            </ul>
          </nav>

          <ul className={styles.byline_credit_list}>
            <li className={styles.byline_credit_list_item}>
              <h4 className={styles.byline_credit_list_item_role}>Journalist</h4>
              <p className={styles.byline_credit_list_item_names}>
                <a href="mailto:christine.presttun@nrk.no">Christine Præsttun</a>
              </p>
              <p className={styles.byline_credit_list_item_names}>
                <a href="mailto:tormod.strand@nrk.no">Tormod Strand</a>
              </p>
            </li>

            <li className={styles.byline_credit_list_item}>
              <h4 className={styles.byline_credit_list_item_role}>Digital historieutvikling</h4>
              <p className={styles.byline_credit_list_item_names}>
                Johannes Odland og Glen William Imrie{' '}
              </p>
            </li>

            <li className={styles.byline_credit_list_item}>
              <h4 className={styles.byline_credit_list_item_role}>Illustrasjoner</h4>
              <p className={styles.byline_credit_list_item_names}>
                Esther Bjørneboe, Marco Vaglieri
              </p>
            </li>

            <li className={styles.byline_credit_list_item}>
              <h4 className={styles.byline_credit_list_item_role}>Ansvarlig redaktør</h4>
              <p className={styles.byline_credit_list_item_names}>Thor Gjermund Eriksen</p>
            </li>

            <li className={styles.byline_credit_list_item}>
              <p style={{ marginTop: '40px' }} className={styles.byline_credit_list_item_names}>
                Publisert 8.11.2017
              </p>
            </li>
          </ul>
          <div className={styles.byline_credit_nrklogo}>
            <svg width="3.5em" height="1.4em" aria-hidden="true">
              <use xlinkHref="#nrk-logo-nrk" />
            </svg>
            <span className="nrk-sr">Gå til nrk.no</span>
          </div>
        </div>
      </div>
    )
  }
}
